<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    class="properties-field"
  >
    <div class="wrap-properties">
      <!-- Configuration Title -->
      <div class="properties-field-title">
        <h4 class="title">
          Properties
          <div class="title-badge">Button</div>
        </h4>
        <div
          class="close-properties"
          @click="closeConfiguration"
        >
          &times;
        </div>

        <div class="wrap-type">
          <img
            src="@/assets/new-form-ui/icon/button.svg"
            height="32"
          >
          <div class="text-type">{{ label }}</div>
        </div>
      </div>

      <!-- Configuration Content -->
      <div class="properties-field-content">
        <div class="section-field input-field">
          <b-row>
            <!-- Label Field -->
            <b-col cols="12">
              <b-form :class="{'error-input' : $v.dataSetup.label.$error}">
                <div class="title-field">
                  <label> Label </label>
                </div>
                <j-input
                  v-model="dataSetup.label"
                  placeholder="Enter button label"
                />
              </b-form>
            </b-col>

            <!-- Method Field -->
            <b-col
              v-if="isRevisionBtn"
              cols="12"
            >
              <b-form :class="{'error-input' : $v.dataSetup.revision_method.$error}">
                <div class="title-field">
                  <label> Method </label>
                </div>
                <j-single-select
                  v-model="dataSetup.revision_method"
                  :options="methodOptions"
                  :placeholder="'Select Method'"
                  label="name"
                />
              </b-form>
            </b-col>
          </b-row>
        </div>

        <!-- Configuration -->
        <div class="section-field input-field">
          <h4 class="title-section">Configuration</h4>

          <!-- Hidden Properties -->
          <div class="configuration-section">
            <b-form>
              <div class="configuration-toggle-in-title">
                <div class="wrap-title">
                  <h4 class="configuration-section-title">Hidden</h4>
                  <p class="configuration-section-desc m-0">
                    The button is invisible, but still affect layout as normal.
                  </p>
                </div>
                <j-switch v-model="dataSetup.is_hidden" />
              </div>
            </b-form>
          </div>
        </div>

        <!-- Custom Actions -->
        <div
          v-if="!isRevisionBtn"
          class="section-field input-field"
        >
          <h4 class="title-section">Custom Actions</h4>

          <!-- Before Action -->
          <div class="configuration-section">
            <div class="div-custom-action">
              <div class="wrap-left">
                <img
                  src="@/assets/new-form-ui/icon/script-action.svg"
                  class="icon"
                >
                <div>
                  <p class="title-div">
                    Before Action
                    <img
                      v-if="dataSetup.script_before || dataSetup.container_script_before_is_not_valid || dataSetup.container_script_before_is_not_valid_message"
                      src="@/assets/new-form-ui/icon-active/check-circle-active.svg"
                    >
                  </p>
                  <p class="desc-div">
                    Actions to be executed <b>before</b> the main process (CRUD) is executed.
                  </p>
                </div>
              </div>

              <img
                src="@/assets/new-form-ui/setup.svg"
                class="open-modal"
                @click="openModalScriptBefore"
              >
            </div>
          </div>

          <!-- After Action -->
          <div class="configuration-section">
            <div class="div-custom-action">
              <div class="wrap-left">
                <img
                  src="@/assets/new-form-ui/icon/script-action.svg"
                  class="icon"
                >
                <div>
                  <p class="title-div">
                    After Action
                    <img
                      v-if="dataSetup.script || dataSetup.variable_message || dataSetup.variable_redirect"
                      src="@/assets/new-form-ui/icon-active/check-circle-active.svg"
                    >
                  </p>
                  <p class="desc-div">
                    Actions to be executed <b>after</b> the main process (CRUD) is executed.
                  </p>
                </div>
              </div>

              <img
                src="@/assets/new-form-ui/setup.svg"
                class="open-modal"
                @click="openModalScriptAfter"
              >
            </div>
          </div>

          <!-- Type Configuration -->
          <!-- <div class="configuration-section">
            <h4 class="configuration-section-title mb-2">Type</h4>

            <div class="d-flex align-items-center">
              <div
                v-for="option in typeOptions"
                :key="option.id"
                :class="{ 'active': option.id === dataSetup.type }"
                class="div-list-language"
                @click="dataSetup.type = option.id"
              >
                {{ option.name }}
              </div>
            </div>
          </div> -->

          <!-- Other Variable -->
          <div
            v-if="dataSetup.container_params || dataSetup.container_record"
            class="configuration-section"
          >
            <p class="configuration-section-title mb-2">Other Variable</p>

            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <div class="title-field">
                  <label> Variable Params </label>
                </div>
                <j-input
                  v-model="dataSetup.container_params"
                  :error-required="false"
                  :disabled="true"
                />
              </b-col>
              <b-col cols="12">
                <div class="title-field">
                  <label> Variable Record </label>
                </div>
                <j-input
                  v-model="dataSetup.container_record"
                  :error-required="false"
                  :disabled="true"
                />
              </b-col>
            </b-row>
          </div>

          <!-- Mandatory Note -->
          <div
            v-if="mode === 'approve' || mode === 'approveUpdate'"
            class="configuration-section"
          >
            <b-form>
              <div class="configuration-toggle-in-title">
                <div class="wrap-title">
                  <h4 class="configuration-section-title">Mandatory Note</h4>
                  <p class="configuration-section-desc m-0">
                    Note before action will be mandatory
                  </p>
                </div>
                <j-switch v-model="dataSetup.config_dialog_message.is_note_mandatory"/>
              </div>
            </b-form>
          </div>
        </div>
      </div>

      <!-- Button Properties -->
      <div class="properties-field-button">
        <button
          class="button-border"
          @click="resetConfiguration"
        >
          <img src="@/assets/new-form-ui/icon/reset.svg">
          Reset
        </button>

        <div class="d-flex align-items-center">
          <button
            class="button-border mr-2"
            @click="closeConfiguration"
          >
            Close
          </button>

          <button
            class="button-blue"
            @click="submitForm"
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, no-console, camelcase */
import { required, requiredIf } from 'vuelidate/lib/validators';
import { mapActions, mapState } from 'vuex';
import jSwitch from '@/components/inputs/jSwitch';
import jMixAutoScroll from '@/mixins/jMixAutoScroll';

export default {
  name: 'NativeButtonConfiguration',

  components: {
    jSwitch,
  },

  mixins: [jMixAutoScroll],

  props: {
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    mode: {
      type: String,
      default: '',
    },
    isRevisionBtn: {
      type: Boolean,
      default: false,
    },
    fieldDetail: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      dataSetup: {
        label: '',
        script: '',
        script_before: '',
        container_script_before_is_not_valid: '',
        container_script_before_is_not_valid_message: '',
        variable_message: '',
        variable_redirect: '',
        container_params: '',
        container_record: '',
        type: null,
        is_hidden: false,
        revision_method: null,
        config_dialog_message: {},
        is_use_confirmation_message: false,
        custom_confirmation_message: '',
        dynamic_confirmation_message: '',
        dynamic_confirmation_message_params: null,
      },
      typeOptions: [
        {
          id: 'confirmation',
          name: 'Confirmation',
        },
        {
          id: 'message',
          name: 'Message',
        },
      ],
      methodOptions: [
        {
          id: 1,
          name: 'Resubmit',
        },
        {
          id: 2,
          name: 'Rollback',
        },
      ],
    };
  },

  computed: {
    ...mapState('jStoreExperienceManagerV2', ['showModalScriptBeforeAfter', 'sourceScriptBeforeAfter']),
  },

  watch: {
    showModalScriptBeforeAfter(val) {
      if (!val) {
        if (this.sourceScriptBeforeAfter) {
          if (this.sourceScriptBeforeAfter.type === 'before') {
            this.dataSetup.script_before = this.sourceScriptBeforeAfter.script_before;
            this.dataSetup.container_script_before_is_not_valid = this.sourceScriptBeforeAfter.container_script_before_is_not_valid;
            this.dataSetup.container_script_before_is_not_valid_message = this.sourceScriptBeforeAfter.container_script_before_is_not_valid_message;
            this.dataSetup.is_use_confirmation_message = this.sourceScriptBeforeAfter.is_use_confirmation_message;
            this.dataSetup.custom_confirmation_message = this.sourceScriptBeforeAfter.custom_confirmation_message;
            this.dataSetup.dynamic_confirmation_message = this.sourceScriptBeforeAfter.dynamic_confirmation_message;
            this.dataSetup.dynamic_confirmation_message_params = this.sourceScriptBeforeAfter.dynamic_confirmation_message_params;
          } else if (this.sourceScriptBeforeAfter.type === 'after') {
            this.dataSetup.script = this.sourceScriptBeforeAfter.script;
            this.dataSetup.variable_message = this.sourceScriptBeforeAfter.variable_message;
            this.dataSetup.variable_redirect = this.sourceScriptBeforeAfter.variable_redirect;
          }
        }
      }
    },
  },

  created() {
    this.setPropsData();
  },

  methods: {
    ...mapActions('jStoreExperienceManagerV2', ['toggleModalScriptBeforeAfter']),

    setPropsData() {
      if (this.fieldDetail) {
        const fieldDetail = JSON.parse(JSON.stringify(this.fieldDetail));
        this.dataSetup.label = fieldDetail.label;
        this.dataSetup.script = fieldDetail.script;
        this.dataSetup.script_before = fieldDetail.script_before;
        this.dataSetup.container_script_before_is_not_valid = fieldDetail.container_script_before_is_not_valid;
        this.dataSetup.container_script_before_is_not_valid_message = fieldDetail.container_script_before_is_not_valid_message;
        this.dataSetup.variable_message = fieldDetail.variable_message;
        this.dataSetup.variable_redirect = fieldDetail.variable_redirect;
        this.dataSetup.container_params = fieldDetail.container_params;
        this.dataSetup.container_record = fieldDetail.container_record;
        this.dataSetup.type = fieldDetail.type || 'message';
        this.dataSetup.is_hidden = fieldDetail.is_hidden;
        this.dataSetup.revision_method = fieldDetail.revision_method;
        this.dataSetup.config_dialog_message = fieldDetail.config_dialog_message || {};
        this.dataSetup.is_use_confirmation_message = fieldDetail.is_use_confirmation_message;
        this.dataSetup.custom_confirmation_message = fieldDetail.custom_confirmation_message;
        this.dataSetup.dynamic_confirmation_message = fieldDetail.dynamic_confirmation_message;
        this.dataSetup.dynamic_confirmation_message_params = fieldDetail.dynamic_confirmation_message_params;

        if (this.mode === 'approve' || this.mode === 'approveUpdate') {
          this.dataSetup.config_dialog_message.is_note_mandatory = fieldDetail.config_dialog_message ? fieldDetail.config_dialog_message.is_note_mandatory : false;
        }
        if (this.mode === 'revision' && !this.fieldDetail.revision_method) this.dataSetup.is_hidden = true;
      }
    },

    openModalScriptBefore() {
      const data = {
        type: 'before',
        script_before: this.dataSetup.script_before,
        container_script_before_is_not_valid: this.dataSetup.container_script_before_is_not_valid,
        container_script_before_is_not_valid_message: this.dataSetup.container_script_before_is_not_valid_message,
        is_use_confirmation_message: this.dataSetup.is_use_confirmation_message,
        custom_confirmation_message: this.dataSetup.custom_confirmation_message,
        dynamic_confirmation_message: this.dataSetup.dynamic_confirmation_message,
        dynamic_confirmation_message_params: this.dataSetup.dynamic_confirmation_message_params,
      };

      this.toggleModalScriptBeforeAfter({ status: true, data });
    },

    openModalScriptAfter() {
      const data = {
        type: 'after',
        script: this.dataSetup.script,
        variable_message: this.dataSetup.variable_message,
        variable_redirect: this.dataSetup.variable_redirect,
      };

      this.toggleModalScriptBeforeAfter({ status: true, data });
    },

    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$emit('submit-configuration', this.dataSetup);
      }
    },

    closeConfiguration() {
      this.$emit('close-configuration');

      setTimeout(() => {
        this.dataSetup = {
          label: '',
          script: '',
          script_before: '',
          container_script_before_is_not_valid: '',
          container_script_before_is_not_valid_message: '',
          variable_message: '',
          variable_redirect: '',
          container_params: '',
          container_record: '',
          type: null,
          is_hidden: false,
          revision_method: null,
          is_use_confirmation_message: false,
          custom_confirmation_message: '',
          dynamic_confirmation_message: '',
          dynamic_confirmation_message_params: null,
        };
      }, 400);
    },

    resetConfiguration() {
      if (this.fieldDetail) {
        this.setPropsData();
      } else {
        this.dataSetup = {
          label: '',
          script: '',
          script_before: '',
          container_script_before_is_not_valid: '',
          container_script_before_is_not_valid_message: '',
          variable_message: '',
          variable_redirect: '',
          container_params: '',
          container_record: '',
          type: null,
          is_hidden: false,
          revision_method: null,
          config_dialog_message: {},
          is_use_confirmation_message: false,
          custom_confirmation_message: '',
          dynamic_confirmation_message: '',
          dynamic_confirmation_message_params: null,
        };
      }
    },
  },

  validations() {
    const validate = {
      dataSetup: {
        label: { required },
        script: { },
        script_before: { },
        container_script_before_is_not_valid: { },
        container_script_before_is_not_valid_message: { },
        config_dialog_message: { },
        variable_message: { },
        variable_redirect: { },
        container_params: { },
        container_record: { },
        type: { },
        is_hidden: { },
        revision_method: {
          required: requiredIf(() => this.isRevisionBtn),
        },
        is_use_confirmation_message: { },
        custom_confirmation_message: { },
        dynamic_confirmation_message: { },
        dynamic_confirmation_message_params: { },
      },
    };
    return validate;
  },
};
</script>




// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/configuration/NativeButtonConfiguration.vue